import React from "react";
import { Link } from "react-router-dom";

function BackHomeLink() {
  return (
    <div
      style={{
        background: "none",
        boxShadow: "none",
        padding: 0,
        margin: "0 0 16px 0",
        minWidth: "unset",
        textAlign: "center",
      }}
    >
      <Link to="/" className="back-home-btn">
        &#8592; Home
      </Link>
    </div>
  );
}

export default BackHomeLink;
